import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { FiCheckCircle } from 'react-icons/fi';
import { LogoMark } from './common/Logo';

const POINTS = [
  'Registration and insurance verified before listing',
  'No commission markup on session fees',
  'Free to search, and free to switch',
];

export default function AboutSection() {
  return (
    <section className="mm-section pb-0" id="about">
      <Container>
        <div className="mm-about">
          <Row className="mm-about__inner align-items-center g-4 g-lg-5">
            <Col lg={7}>
              <div
                className="mm-eyebrow mb-3"
                style={{ color: 'rgba(255,255,255,0.75)' }}
              >
                About MindlyFriend
              </div>

              <h2 className="mm-about__title">
                Therapy is hard enough. Finding a therapist shouldn&rsquo;t be.
              </h2>

              <p className="mm-about__text">
                MindlyFriend exists because the hardest part of getting help is often
                the part before it starts &mdash; the endless directories, the
                unanswered emails, the not knowing whether the person on the
                other end is actually qualified. We verify every clinician
                ourselves, publish their real fees, and let you filter by what
                you&rsquo;re going through rather than by job title.
              </p>

              <ul className="mm-about__points">
                {POINTS.map((point) => (
                  <li key={point}>
                    <FiCheckCircle size={17} aria-hidden="true" />
                    {point}
                  </li>
                ))}
              </ul>

              <Button className="mm-about__cta" href="#about-more">
                Read more
              </Button>
            </Col>

            {/* Source order keeps the copy first so screen readers and the
                lg+ layout both read text-then-mark. Below lg the columns stack
                and the order utilities float the mark to the top, so the panel
                opens on the brand instead of on a wall of text. */}
            <Col lg={5} className="order-first order-lg-last">
              <div className="mm-about__graphic">
                <span className="mm-about__glow" aria-hidden="true" />
                <span className="mm-about__mark" aria-hidden="true">
                  {/* Mono on the saturated blue panel — the brand blue stroke
                      would vanish into the background. */}
                  <LogoMark size={140} tone="mono" />
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}
